import { useEffect, useState } from "react";
export var useDebounce = function (value, delay, shouldDelay) {
    if (shouldDelay === void 0) { shouldDelay = true; }
    // State and setters for debounced value
    var _a = useState(value), debouncedValue = _a[0], setDebouncedValue = _a[1];
    useEffect(function () {
        // Update debounced value after delay
        var handler;
        if (shouldDelay) {
            handler = setTimeout(function () {
                setDebouncedValue(value);
            }, delay);
        }
        else {
            setDebouncedValue(value);
        }
        // Cancel the timeout if value changes (also on delay change or unmount)
        // This is how we prevent debounced value from updating if value is changed ...
        // .. within the delay period. Timeout gets cleared and restarted.
        return function () {
            setDebouncedValue(value);
            clearTimeout(handler);
        };
    }, [value, delay]); // Only re-call effect if value or delay changes
    return debouncedValue;
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/use-debounce/useDebounce.ts
// module id = 1133
// module chunks = 3